import { useI18n } from "@excalidraw/excalidraw/i18n";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";
import React from "react";

export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
}> = React.memo((props) => {
  const { t } = useI18n();

  return (
    <WelcomeScreen>
      <WelcomeScreen.Hints.MenuHint>
        {t("welcomeScreen.app.menuHint")}
      </WelcomeScreen.Hints.MenuHint>
      <WelcomeScreen.Hints.ToolbarHint />
      <WelcomeScreen.Hints.HelpHint />
      <WelcomeScreen.Center>
        <WelcomeScreen.Center.Logo>
          <img
            src="/Whiteboard-Intro.svg"
            alt="Sisi Whiteboard"
            style={{
              width: 380,
              opacity: 0.15,
              pointerEvents: "none",
              marginBottom: 24,
            }}
          />
        </WelcomeScreen.Center.Logo>
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
